<template>
  <v-dialog max-width="550px" v-model="dialog" @keydown.enter.prevent="save">
    <v-card>
      <v-card-title>
        <span class="headline">Merge Config</span>
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="4" md="4">
            <r-item-merge-mode :model.sync="mode"/>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-checkbox v-model="model.onlyFirstReward" label="Only First Reward" class="mt-3" hide-details/>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-checkbox v-model="model.ignoreCopycat" label="Ignore Copycat" class="mt-3" hide-details/>
          </v-col>
        </v-row>
        <v-row dense class="pt-4">
          <v-expansion-panels v-model="panels">
            <v-expansion-panel :disabled="mode.id !== 2">
              <v-expansion-panel-header v-slot="{ open }">
                <v-row no-gutters>
                  <span style="margin-top: 5px">Generator:</span>
                  <v-spacer/>
                  <v-fade-transition>
                            <span style="display: inline-flex" v-if="open">
                                <v-divider class="mx-1" vertical/>
                            </span>
                  </v-fade-transition>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <r-item-generator-model :model.sync="model.generator"/>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <r-reward-panel :disabled="mode.id == 0" :model.sync="model.reward" title="Rewards"/>
          </v-expansion-panels>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>Cancel</v-btn>
        <v-btn @click="save" color="blue darken-1" text>Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>


import {ViewRules} from "@/common/ViewRules";
import {ItemMergeConfig} from "@/modules/redactor/models/item/merge/ItemMergeConfig";
import {ItemMergeMode} from "@/modules/redactor/models/item/merge/ItemMergeMode";

import RRewardPanel from "@/modules/redactor/views/reward/r-reward-panel.vue";
import RItemMergeMode from "@/modules/redactor/views/item/merge/r-item-merge-mode.vue";
import RItemGeneratorModel from "@/modules/redactor/views/reward-generator/r-reward-generator-model.vue";

export default {
  name: "r-item-merge-config",
  components: {RItemGeneratorModel, RItemMergeMode, RRewardPanel},
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: new ItemMergeConfig(),
    rules: ViewRules.READONLY,
    panels: []
  }),
  computed: {
    mode: {
      get: function () {
        return this.model ? this.model.mode : ItemMergeMode.DISABLED;
      },
      set: function (value) {
        this.model.mode = value;
      }
    }
  },
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new ItemMergeConfig();
      this.panels = [];
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.empty()) {
        this.resolve(null);
        this.discard();
      } else if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    }
  },
  watch: {
    mode() {
      this.panels = [];
    }
  },
}
</script>